"use strict";

var app = angular.module("analytics");

app.controller("ReportsPanelCtrl", [
  "$scope",
  "categoryFactory",
  "organizationFactory",
  "reportFactory",
  "reportingReportFactory",
  "storageFactory",
  function ($scope, categoryFactory, organizationFactory, reportFactory, reportingReportFactory, storageFactory) {
    $scope.selected = reportFactory.getSelected();
    var parentScope = reportFactory.getParentScope();

    $scope.organizationData = organizationFactory.data;
    reportingReportFactory.getAll().then(function (reportingReportsData) {
      $scope.reportingReportsData = reportingReportsData;
      $scope.reportingReportsData.forEach((r) => {
        r.parsedName =
          r.name +
          " - " +
          (r.modifiedAt ? new Date(r.modifiedAt).toLocaleDateString() : new Date(r.createdAt).toLocaleDateString());
      });
    });
    $scope.categoryData = categoryFactory.data;
    $scope.uploadedFiles = [];

    $scope.filesToUpload = null;

    $scope.organizationSearchTerm = "";

    $scope.clearOrganizationSearchTerm = function () {
      $scope.organizationSearchTerm = "";
    };

    function fetchFiles() {
      if ($scope.selected && $scope.selected.id) {
        storageFactory.listFilesInContainer($scope.selected.id).then((files) => {
          $scope.uploadedFiles = files;
        });
      }
    }

    fetchFiles();

    $scope.save = function () {
      if ($scope.selected.id) {
        //modify
        storageFactory.uploadFile($scope.selected.id, $scope.filesToUpload);

        reportFactory.modify($scope.selected.id, $scope.selected);
      } else {
        //create
        reportFactory.create($scope.selected).then((created) => {
          if ($scope.filesToUpload !== null) {
            storageFactory.uploadFile(created.data.id, $scope.filesToUpload);
          }
        });
      }

      parentScope.closePanel();
    };

    $scope.uploadedFile = function (element) {
      $scope.$apply(function ($scope) {
        $scope.filesToUpload = element.files;
      });
    };

    $scope.deleteFile = function deleteFile(file) {
      storageFactory.deleteFile(file.container, file.name).then(() => {
        fetchFiles();
      });
    };

    $scope.downloadFile = function downloadFile(file) {
      storageFactory.downloadFile(file.container, file.name);
    };
  },
]);
//# sourceMappingURL=reportCtrl.js.map
